import * as types from 'actions/types';
import { createReducer, successType } from 'shared/lib/lib/callAPI';

// Phase B / B2 — reiner Daten-Reducer fuer die "Alle Benachrichtigungen"-Seite.
// Bewusst getrennt vom Glocken-Slice (notificationsReducer). Die getPage()-Action liefert
// { results, totalCount }; bei Success wird das in { data: results, totalCount } abgelegt.
// createReducer wrappt diesen dataReducer in { loading, data, error } -> der Slice ist also
// notificationsOverview = { loading, error, data: { data: [], totalCount: 0 } }.
export const initialState = {
  data: [],
  totalCount: 0,
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case successType(types.GET_NOTIFICATIONS_OVERVIEW):
      if (action.response) {
        return {
          data: action.response.results || [],
          totalCount: action.response.totalCount || 0,
        };
      }
      return state;
    // Mark-as-read spiegeln (analog notificationsReducer): die betroffene Notification
    // im data-Array per pk durch action.response ersetzen, totalCount unverändert. So
    // wechselt eine Card ohne Navigationsziel sofort auf "gelesen" (read_at gesetzt),
    // ohne auf einen Refetch zu warten.
    case successType(types.MARK_NOTIFICATION_AS_READ):
      if (action.response) {
        return {
          ...state,
          data: state.data.map((notification) => notification.pk === action.response.pk
            ? action.response
            : notification),
        };
      }
      return state;
    case types.LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default createReducer([types.GET_NOTIFICATIONS_OVERVIEW], dataReducer);
